import { useChat } from "@chatscope/use-chat";
import { PaperClipIcon, XIcon } from "@heroicons/react/outline";
import { ChangeEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTwilioChat } from "../../hooks/useTwilioChat";
import toast from "react-hot-toast";
type MessageInputProps = {
  value?: string;
  handleChange: (value: string) => void;
  onSend: (text: string | File, type?: string) => void;
  userType: string;
};
export default function MessageInput(props: MessageInputProps) {
  const { value, handleChange, onSend, userType } = props;
  const { sendMessages } = useTwilioChat();
  const { activeConversation } = useChat();
  const LocalBasePath = "page.chat";
  const [currentMessage, setCurrentMessage] = useState("");
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [file, setFile] = useState<ChangeEvent<HTMLInputElement> | null>(null);
  const [nameFile, setNameFile] = useState<string | null>(null);
  const addMessage = async (message: string, file?: File, type?: string) => {
    if (activeConversation?.id && !!message) {
      sendMessages(activeConversation?.id, message, file, type);
    }
  };

  const onSelectFile = async (e: any) => {
    if (!e.target.files || e.target.files.length === 0) return;
    addMessage("test", e.target.files[0], "file");
    onSend(e.target.files[0], "file");
    setFile(null);
    setNameFile(null);
  };

  return (
    <div className="w-full  focus-within:ring-1 focus-within:ring-gray-200 bg-gray-50 md:rounded-md shadow-inner sticky bottom-0">
      <div className="w-full px-8 py-4 ">
        <form>
          <div>
            <textarea
              rows={3}
              name="comment"
              id="comment"
              className="block text-gray-900 w-full focus:outline-none focus:ring-0  bg-transparent   resize-none border-none  text-sm"
              placeholder={t("writeMessages")}
              value={value}
              disabled={!!file}
              onChange={(e) => {
                handleChange(e.target.value);
                setCurrentMessage(e.target.value);
              }}
            />
          </div>
          <div className="flex justify-between pt-[6px] border-t border-gray-100">
            <div className="flex items-center space-x-5">
              <div className=" flex items-center gap-3  text-xs leading-5 font-medium text-gray-400">
                <label
                  htmlFor="file-upload"
                  className=" cursor-pointer   text-xs leading-5 font-medium text-gray-400"
                >
                  <PaperClipIcon className="h-6 w-6" aria-hidden="true" />

                  <input
                    id="file-upload"
                    onChange={(e) => {
                      setNameFile(e?.target?.files?.[0].name ?? "");
                      setFile(e);
                    }}
                    accept="image/*"
                    type="file"
                    className="hidden"
                    disabled={userType === "tutor" || userType === "student"}
                  />
                </label>
                <p className="truncate w-28">
                  {!!nameFile ? nameFile : t("sendFile")}
                </p>
                {!!nameFile && (
                  <button
                    className="border-none bg-transparent  "
                    onClick={(e) => {
                      e.stopPropagation();
                      setFile(null);
                      setNameFile(null);
                    }}
                  >
                    <XIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                )}
              </div>
            </div>
            <div className="flex-shrink-0">
              <button
                type="button"
                className="inline-flex items-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium text-white shadow-sm  bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-600"
                onClick={() => {
                  if (!!currentMessage) {
                    onSend(currentMessage);
                    addMessage(currentMessage);
                    setCurrentMessage("");
                  } else if (!!file) {
                    onSelectFile(file);
                  }
                }}
              >
                {t("send")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
